import { dataLayer } from 'analytics/data-layer';
import locator from 'utils/locator';

export function trackClickInteraction({
  classification,
  linkText,
  linkUrl,
  lineNumber,
  verticalPosition,
}: {
  classification: string;
  linkText?: string;
  linkUrl?: string;
  lineNumber?: string;
  verticalPosition?: string;
}) {
  dataLayer.push({
    event: 'click_interaction',
    classification,
    link_text: linkText,
    link_url: linkUrl,
    item_id: lineNumber,
    page_location: locator.origin + locator.pathname,
    vertical_pos: verticalPosition,
  });
}
